import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {
  SettingOutlined, MenuUnfoldOutlined,
  MenuFoldOutlined,
} from '@ant-design/icons';
import { Dropdown, Layout, notification } from 'antd';
import HeaderMenu from './HeaderMenu';
import './HeaderComponent.scss';
import { toggleMenuCollapsed } from '../../redux/actions/app';
import NotificationsComponent from './notificationsComponent/NotificationsComponent';
import { userLogout, isSuperAgentError, ResponseWrapper } from '../../dataSource/requests';
import { removeUserFromStorage, getUserRole, getUserPermissions } from '../../utils/users';
import { GENERIC_ERROR_MESSAGE } from '../../utils/responseMessages';

const HeaderComponent = (): React.ReactElement => {
  const navigate = useNavigate();
  const [userType, setUserType] = useState<string | null>('');
  const dispatch = useDispatch();
  const collapsed = useSelector((state) => state.app.collapsed);
  const headerTitle = useSelector((state) => state.app.headerTitle);

  const toggleMenu = (): void => {
    dispatch(toggleMenuCollapsed());
  };

  const handleUserType = (): void => {
    setUserType(getUserRole());
  };

  const handleLogout = async (): Promise<void> => {
    let response: ResponseWrapper | undefined;
    let responseError: ResponseWrapper | undefined;

    try {
      response = await userLogout({
        clientOptions: {
          returnAll: true,
        },

        frontConfigs: {
          navigateFunction: navigate,
        },
      });
    } catch (error: unknown) {
      if (isSuperAgentError(error)) {
        responseError = error.response;
      }

      console.log(error);
    }

    switch (true) {
      case (response?.body?.code === 1003):
        // "User logged out successfully", 1003
        removeUserFromStorage();
        navigate('/login');
        break;

      case (responseError?.body?.code === -1003):
        // "User should be logged in to perform this operation", -1003
        notification.error({
          message: 'Erro',
          description: 'Erro ao deslogar do sistema.',
        });
        removeUserFromStorage();
        navigate('/login');
        break;

      default:
        notification.error({
          message: 'Erro',
          description: GENERIC_ERROR_MESSAGE,
        });
        break;
    }
  };

  const handleMenuClick = (args: { key: string }): void => {
    if (args.key === 'logout') {
      handleLogout();
    } else if (args.key === 'changePassword') {
      navigate('/change-password');
    } else if (args.key === 'deleteAccount') {
      navigate('/delete-account');
    } else if (args.key === 'profileEdit') {
      navigate('/profile/edit-my-profile');
    } else if (args.key === 'notificationsettings') {
      navigate('/notification/settings');
    }
  };

  useEffect(() => {
    handleUserType();
    return () => {
      setUserType(null);
    };
  }, []);

  return (
    <Layout.Header id="HeaderComponent">
      <div className="header-title-container">
        {
          collapsed
            ? (
              <MenuUnfoldOutlined className="trigger" onClick={toggleMenu} />
            )
            : (
              <MenuFoldOutlined className="trigger" onClick={toggleMenu} />
            )
        }
        <div className="header-title">{headerTitle}</div>
      </div>

      <div className="header-info">
        {
          ((getUserPermissions() || []).includes('Notificações')) ? (
            <NotificationsComponent />
          ) : null
        }

        <div className="custom-header-menu-user-info">
          <Dropdown
            overlay={
              (): JSX.Element => (
                <HeaderMenu
                  user={userType}
                  onClick={handleMenuClick}
                />
              )
            }
            trigger={['click']}
          >
            <div className="dropdown-logout-container">
              <SettingOutlined className="HeaderComponent__settings-icon" />
            </div>
          </Dropdown>
        </div>
      </div>
    </Layout.Header>
  );
};

HeaderComponent.propTypes = {};
HeaderComponent.defaultProps = {};

export default HeaderComponent;
